export const headCells = [
    {
      id: "sNo",
      numeric: false,
      disablePadding: true,
      label: "S.No",
    },
    {
      id: "labName",
      numeric: false,
      disablePadding: false,
      label: "Lab Name",
    },
    {
      id: "email",
      numeric: false,
      disablePadding: false,
      label: "Email",
    },
    {
      id: "phone",
      numeric: false,
      disablePadding: false,
      label: "Phone",
    },
    {
      id: "onboardedOn",
      numeric: false,
      disablePadding: false,
      label: "Onboarded On",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Status",
    },
    {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
    },
  ];
  